import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomNavbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";

function Doctors() {

  const doctors = [
    {
      id: "trupti",
      name: "Dr. Trupti Sudarshan Hambire",
      img: "/drTrupti.jpeg",
      specialty: "Cosmetologist And Ayurvedacharya"
    },
    {
      id: "vishnu",
      name: "Dr. Vishnu Shivaji Shinde",
      img: "/drVishnu.jpeg",
      specialty: "Family Physician"
    }
  ];

  return (
    <>
      <CustomNavbar />

      <Container className="py-5">

        <h2 className="text-center mb-5 fw-bold">
          OUR DOCTORS
        </h2>

        <Row className="justify-content-center">

          {doctors.map((doc) => (
            <Col md={4} key={doc.id} className="mb-4">

              <Card className="shadow doctor-card text-center">

                <Card.Img
                  variant="top"
                  src={doc.img}
                />

                <Card.Body>

                  <Card.Title>{doc.name}</Card.Title>

                  <Card.Text>
                    {doc.specialty}
                  </Card.Text>

                  <Link
                    to={`/doctor/${doc.id}`}
                    className="btn btn-warning"
                  >
                    View Profile
                  </Link>

                </Card.Body>

              </Card>

            </Col>
          ))}

        </Row>

      </Container>

      <Footer />
    </>
  );
}

export default Doctors;